var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"share_con",on:{"click":function($event){return _vm.$emit('doCloseShare')}}},[_c('img',{attrs:{"src":require("../assets/img/share.png")}})]),_c('div',{staticClass:"share_bg"})])}
var staticRenderFns = []

export { render, staticRenderFns }